import React, { useMemo, useState } from 'react';
import { fechaCorta, hoyGT } from '../finanzas/estados';
import { sumarDiasCalendario } from '../../utils/dates';

export const menosDias = (iso, d) => sumarDiasCalendario(iso, -d);
const PERIODOS = [['hoy', 'Hoy'], ['ayer', 'Ayer'], ['semana', 'Semana'], ['mes', 'Mes'], ['dia', 'Día específico'], ['rango', 'Rango']];

/** Periodo seleccionable: atajos (hoy, ayer, semana, mes) o fechas a elección. Fechas en hora de Guatemala. */
export function usePeriodo(inicial = 'semana') {
  const hoy = hoyGT();
  const [periodo, setPeriodo] = useState(inicial);
  const [dia, setDia] = useState(hoy);
  const [rango, setRango] = useState({ desde: menosDias(hoy, 6), hasta: hoy });
  const { desde, hasta } = useMemo(() => {
    if (periodo === 'hoy') return { desde: hoy, hasta: hoy };
    if (periodo === 'ayer') { const d = menosDias(hoy, 1); return { desde: d, hasta: d }; }
    if (periodo === 'semana') return { desde: menosDias(hoy, 6), hasta: hoy };
    if (periodo === 'mes') return { desde: `${hoy.slice(0, 8)}01`, hasta: hoy };
    if (periodo === 'dia') return { desde: dia, hasta: dia };
    return rango.desde <= rango.hasta ? rango : { desde: rango.hasta, hasta: rango.desde };
  }, [periodo, dia, rango, hoy]);
  return { periodo, setPeriodo, dia, setDia, rango, setRango, desde, hasta, hoy };
}

/** Botones de periodo + campos de fecha cuando aplica. `children` se agrega en la fila de fechas. */
export default function PeriodoFiltro({ p, children }) {
  return <>
    <div className="prov-filtros" role="group" aria-label="Periodo">
      <span className="filtro-titulo">Periodo</span>
      {PERIODOS.map(([id, label]) => (
        <button key={id} type="button" className={`fx-btn ${p.periodo === id ? 'fx-btn--primary' : ''}`} aria-pressed={p.periodo === id} onClick={() => p.setPeriodo(id)}>{label}</button>))}
    </div>
    <div className="prov-filtros">
      {p.periodo === 'dia' && <label>Fecha <input type="date" value={p.dia} max={p.hoy} onChange={(e) => e.target.value && p.setDia(e.target.value)} /></label>}
      {p.periodo === 'rango' && <>
        <label>Inicio <input type="date" value={p.rango.desde} max={p.hoy} onChange={(e) => e.target.value && p.setRango({ ...p.rango, desde: e.target.value })} /></label>
        <label>Fin <input type="date" value={p.rango.hasta} max={p.hoy} onChange={(e) => e.target.value && p.setRango({ ...p.rango, hasta: e.target.value })} /></label>
      </>}
      {p.periodo !== 'dia' && p.periodo !== 'rango' && <span className="fx-empty" style={{ padding: 0 }}>{p.desde === p.hasta ? fechaCorta(p.desde) : `${fechaCorta(p.desde)} – ${fechaCorta(p.hasta)}`}</span>}
      {children}
    </div>
  </>;
}
